import { isPlatformBrowser } from '@angular/common';
import { Injectable, NgModule, ModuleWithProviders, inject, PLATFORM_ID, provideAppInitializer } from '@angular/core';

import { AddonTapfiliateScript } from './tapfiliate.script';
import { AddonTapfiliateService } from './tapfiliate.service';
import { AddonPageAddonsRenderer } from '../../shared/page-addons-renderer.helper';
import { EnumAddonPageAddonInjection } from '../../shared/page-addons.interface';


@Injectable()
class AddonDummyTapfiliateService extends AddonTapfiliateService {
	override detect(): void {}
	override trackConversion(): void {}
}


@NgModule()
export class AddonTapfiliateModule {

	static register(config: IAddonTapfiliateConfig): ModuleWithProviders<AddonTapfiliateModule> {
		return {
			ngModule	: AddonTapfiliateModule,
			providers	: [
				{
					provide		: EnumAddonPageAddonInjection.TapfiliateAccountId,
					useValue	: config.ACCOUNT_ID as string
				},
				AddonPageAddonsRenderer,
				AddonTapfiliateScript,
				AddonTapfiliateService,
				provideAppInitializer(() => {
					if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
					inject(AddonTapfiliateScript).create();
				})
			]
		};
	}

	static dummy(): ModuleWithProviders<AddonTapfiliateModule> {
		return {
			ngModule	: AddonTapfiliateModule,
			providers	: [
				AddonTapfiliateScript,
				{
					provide		: EnumAddonPageAddonInjection.TapfiliateAccountId,
					useValue	: null
				},
				{
					provide		: AddonTapfiliateService,
					useClass	: AddonDummyTapfiliateService
				}
			]
		};
	}
}


//** Interfaces --------------------------------- */
export interface IAddonTapfiliateConfig {
	ACCOUNT_ID: string;
}
